import api from './api';
import {trackPromise} from "react-promise-tracker";

const ProcessoService = {
    buscarProcessosCpf: (cpf) => {
       
        return trackPromise(api.get('/processo/cpf/'+cpf));
    },
    buscarDadosProcesso: (id) => {
        return trackPromise(api.get('/processo/'+id));
    },
    buscarFluxoPagamento: (id) => {
        return trackPromise(api.get('/processo/'+id+'/pagamento'));
    },
    list: (nome) => {
        let uri = '/processo/nome';
        return api['post'].call(api, uri, {dados: nome});
    },
    buscarBoleto: (idProcesso, idParcela) => {
        return trackPromise(api.get(`/processo/${idProcesso}/boleto/${idParcela}`));
    }
};

export default ProcessoService;
